import qs from "qs";
/**
 * 根据配置获取路径公共方法
 * ~：获取相对于html路径
 * $：获取静态资源的路径
 * @：获取组件的源码路径
 * !：获取idm的目录路径
 * 默认返回webRoot的default配置的路径
 * @param {String} url 
 * @param {String} rootPath 
 * @param {String} projectNo 项目编号
 * @returns 
 */
function getWebPath(url, rootPath,projectNo) {
    if (!url) {
        return "";
    }
    const base64Reg = RegExp(/^data:(image|audio)\/.*;base64,/)
    let isHtmlDir = false;
    let isAssetsDir = false;
    let isModuleDir = false;
    let isIdmDir = false;
    if (url.startsWiths("~")) {
        isHtmlDir = true;
        url = url.substr(1);
    } else if (url.startsWiths("$")) {
        isAssetsDir = true;
        url = url.substr(1);
    } else if (url.startsWiths("@")) {
        isModuleDir = true;
        url = url.substr(1);
    } else if (url.startsWiths("!")) {
        isIdmDir = true;
        url = url.substr(1);
    } else if (base64Reg.test(url)) {
        return url
    } else if (url.startsWiths(rootPath || IDM.setting.webRoot.default)){
        return url
    }
    if (url.startsWiths("/")) {
        url = url.substr(1);
    } else if (url.startsWiths("./") || url.startsWiths("../") || url.startsWiths("http://") || url.startsWiths("https://")) {
        return url;
    }
    if (isHtmlDir) {
        return IDM.setting.webRoot.htmlDir + url;
    } else if (isAssetsDir) {
        return IDM.setting.webRoot.assetsDir + url;
    } else if(isIdmDir){
        let root = rootPath || IDM.setting.webRoot.default;
        return root+(IDM.setting.webRoot.platformNo?IDM.setting.webRoot.platformNo+"/":"")+IDM.setting.webRoot.idm+"/"+url;
    } else if (isModuleDir) {
        if(projectNo&&IDM.setting.applications.useProjectNoSetting&&process.env.NODE_ENV != "development"){
            return IDM.url.getModuleAbsoluteDir(projectNo,rootPath) + url;
        }
        return IDM.setting.webRoot.moduleDir + url;
    } else {
        let root = rootPath || IDM.setting.webRoot.default;
        return root + url;
    }
}
/**
 * 获取组件的绝对路径
 */
function getModuleAbsoluteDir(projectNo,rootPath){
    var purl = IDM.setting.webRoot.moduleAbsoluteDir.replace(/{projectNo}/g, projectNo||IDM.setting.webRoot.projectNo);
    if (purl.startsWiths("/")) {
        purl = purl.substr(1);
    }
    return (rootPath!==false?IDM.setting.webRoot.default:"")+purl;
}
/**
 * 根据配置返回组件模块的资源路径公共方法
 * @param {*} url 资源的地址，会用module的codeSrc的最后一级目录（static）去匹配url的第一级目录，首先会把url的前面./../全部去除，然后再匹配第一级目录，一致也去除，最后拼接
 * @param {*} module 
 */
function getModuleAssetsWebPath(url,module){
    if(!IDM.env_dev){
        //如果为模块下运行则直接原模原样返回
        return url;
    }
    //如果图片转换了base64直接返回
    if(url.startsWiths("data:image")){
        return url;
    }
    if (!url) {
        return "";
    }
    if (url.startsWiths("/")) {
        url = url.substr(1);
    }
    var freplace = function(){
        if(url.startsWiths("./")){
            url=url.replace("./","");
        }else if(url.startsWiths("../")){
            url=url.replace("../","");
        }
        if(url.startsWiths("./")||url.startsWiths("../")){
            freplace();
        }
    }
    freplace();
    //再次判断/是否第一个
    if (url.startsWiths("/")) {
        url = url.substr(1);
    }
    var codeSrcMd = module.codeSrc.substr(0,module.codeSrc.lastIndexOf("/"));
    var codeSrcLastMd = codeSrcMd.substr(codeSrcMd.lastIndexOf("/")+1);
    if(url.startsWiths(codeSrcLastMd+"/")){
        //如果第一级目录匹配
        url = url.replace(codeSrcLastMd+"/","");
    }
    codeSrcMd = codeSrcMd+"/"+url;
    return IDM.url.getWebPath("@"+codeSrcMd,"",module.projectNo);
}

/**
 * 直接获取绝对路径
 * @param {*} url 
 * @returns 
 */
function getAbsolutePath(url) {
    if (url.indexOf("~/") == 0||url.indexOf("/") == 0) {
        url = IDM.url.getWebPath(url.substr(1));
    }
    return url;
}


function stringify(params, options) {
    let defaultOptions = {
        arrayFormat: "repeat"
    };
    options = IDM.mix({}, defaultOptions, options);
    return qs.stringify(params, options);
}

function parse(str, options) {
    let defaultOptions = {
        arrayFormat: "repeat"
    };
    options = IDM.mix({}, defaultOptions, options);
    return qs.parse(str, options);
}

/**
 * 解析url
 * @param url
 */
function analyzing(url) {
    let i;
    if (!url || url === '') {
        return {
            url: null,
            protocol: null,
            slash: null,
            host: null,
            port: null,
            path: null,
            queryString: null,
            hash: null,
            query: {}
        };
    }
    url = decodeURIComponent(url);
    const parse_url = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
    const _result = parse_url.exec(url);
    const names = ['url', 'protocol', 'slash', 'host', 'port', 'path', 'queryString', 'hash'];
    const result = {};
    for (i = 0; i < names.length; i++) {
        result[names[i]] = _result[i];
    }
    result.protocol = result.protocol && (result.protocol + ':');
    result.path = result.slash !== '//' ? ('/' + result.host + '/' + result.path) : '/' + result.path;
    result.host = result.slash !== '//' ? null : result.host;
    if (!result.port) {
        result.port = result.protocol === 'http:' ? '80' : result.protocol === 'https:' ? 8080 : '';
    }
    const _query = {};
    result.queryString = result.queryString || '';
    const query = result.queryString.split('&');
    for (i = 0; i < query.length; i++) {
        const item = query[i].trim();
        let _i = item.indexOf('='),
            _v = '',
            _k = '';
        if (item !== '') {
            if (_i === -1) {
                _k = item;
            } else {
                _v = item.substr(_i + 1);
                _k = item.replace('=' + _v, '');
            }
            if (!_query[_k]) {
                _query[_k] = _v;
            } else if (typeof _query[_k] === 'string') {
                _query[_k] = [_query[_k], _v];
            } else {
                _query[_k] = _query[_k].push(_v);
            }
        }
    }
    result.query = _query;
    return result;
}

function getURLRoot() {
    var theWetRootPath = "";
    try {
        var pathName = window.location.pathname.substring(1);
        var webName = pathName == '' ? '' : pathName.substring(0, pathName.indexOf('/'));

        var slash = "/";
        if (webName === "ctrl" || webName === "form" || !webName) { //如果上下文/的情况下，取的不对
            webName = "";
            slash = "";
        }
        theWetRootPath = window.location.protocol + '//' + window.location.host + '/' + webName + slash;
    } catch (e) {
        console.error(e);
    }

    return theWetRootPath;
}
/*
根据环境的不同获取对应的url
*/
function getContextWebUrl(url){
    const { NODE_ENV } = process.env
    if(NODE_ENV =="production"){
        return getURLRoot()+url
    }else{
        return getWebPath(url)
    }
}

var globalCache = {};
function queryString(key) {
    if (!globalCache["url_queryString"]) {
        globalCache["url_queryString"] = {};
    }
    if (!globalCache["url_queryString"][key]) {
        var url = window.location.hash;
        if(url.indexOf("?")==-1){
            url = window.location.href.split("?").length>1?window.location.href.split("?")[1]:"";
            url ="?"+ url.split("#")[0];
        }
        var oRegex = new RegExp("[?&]" + key + "=([^&]+)", "i");
        var oMatch = oRegex.exec(url);
        if (oMatch && oMatch.length > 1) {
            var val = decodeURI(oMatch[1]);
            globalCache["url_queryString"][key] = val;
            return val;
        } else {
            return "";
        }
    }
    return globalCache["url_queryString"][key];
}
function queryObject(query) {
    query = query||window.location.hash;
    query = query.split("?").length>1?query.split("?")[1]:"";
    if(!query){
        query = window.location.href.split("?").length>1?window.location.href.split("?")[1]:"";
        query = query.split("#")[0];
    }
    if(!query){
        return {}
    }
    var reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
    var obj = {};
    while (reg.exec(query)) {
        obj[RegExp.$1] = RegExp.$2;
    }
    return obj;
}

export default {
    getWebPath,
    getModuleAssetsWebPath,
    getModuleAbsoluteDir,
    getAbsolutePath,
    queryString,
    stringify,
    parse,
    analyzing,
    getURLRoot,
    getContextWebUrl,
    queryObject
};